/** Available preset sort options for carrier sequence ordering. */
export enum CarrierSequencePreset {
  CARRIER_NAME_ASC = "carrierNameAsc",
  CARRIER_NAME_DESC = "carrierNameDesc",
  PREMIUM_LOW_TO_HIGH = "premiumLowToHigh",
  PREMIUM_HIGH_TO_LOW = "premiumHighToLow",
}

/** Human-readable labels for each preset option. */
export const CARRIER_SEQUENCE_PRESET_LABELS: Record<
  CarrierSequencePreset,
  string
> = {
  [CarrierSequencePreset.CARRIER_NAME_ASC]: "By carrier name A\u2013Z",
  [CarrierSequencePreset.CARRIER_NAME_DESC]: "By carrier name Z\u2013A",
  [CarrierSequencePreset.PREMIUM_LOW_TO_HIGH]: "By premium lowest-to-highest",
  [CarrierSequencePreset.PREMIUM_HIGH_TO_LOW]: "By premium highest-to-lowest",
};

/** Persisted sequence order for carriers on SBS pages. */
export interface CarrierSequenceOrder {
  carrierIds: string[];
  appliedPreset: CarrierSequencePreset | null;
}

/** Payload for persisting carrier sequence changes to the backend. */
export interface UpdateCarrierSequenceRequest {
  rfpId: string;
  coverageType: string;
  carrierIds: string[];
  applyToAllPages: boolean;
}

/** Carrier info extracted from proposals for sorting purposes. */
export interface CarrierSortInfo {
  carrierId: string;
  carrierName: string;
  isCurrent: boolean;
  totalPremium: number;
}
